"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.News = News;
var _Card2 = _interopRequireDefault(require("@mui/material/Card"));
var _CardContent2 = _interopRequireDefault(require("@mui/material/CardContent"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Divider2 = _interopRequireDefault(require("@mui/material/Divider"));
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _newsPostAlert = _interopRequireDefault(require("../assets/images/news/news-post-alert.svg"));
var _plottyEmptyState = _interopRequireDefault(require("../assets/images/plotty-empty-state.svg"));
var _components = require("../components");
var _hooks = require("../hooks");
var _services = require("../services");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function News({
  Button: _Button,
  Link,
  small,
  currentPartner,
  currentUser,
  geogroup,
  userType,
  loadAllNews,
  newPostRedirection,
  sx,
  ...props
}) {
  const [initialized, setInitialized] = (0, _react.useState)(false);
  const [newsPosts, setNewsPosts] = (0, _react.useState)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const {
    cancellablePromise,
    cancelPromises
  } = (0, _hooks.useCancellablePromise)();
  (0, _react.useEffect)(() => {
    setInitialized(true);
  }, []);
  (0, _react.useEffect)(() => {
    if (initialized && geogroup) getNewsPosts();
    return () => cancelPromises();
  }, [initialized, geogroup]);
  async function getNewsPosts() {
    cancelPromises();
    setNewsPosts(undefined);
    if (!geogroup) return;
    try {
      if (loadAllNews) {
        const _news = [];
        let hasNext = true;
        let page = 1;
        while (hasNext) {
          const {
            hasNext: _hasNext,
            results: news
          } = await _services.GeogroupService.getNewsPosts(geogroup.id, {
            ordering: '-created',
            page: page++,
            pageSize: 100
          });
          _news.push(...news);
          hasNext = Boolean(_hasNext);
        }
        setNewsPosts(_news);
      } else {
        const {
          results: news
        } = await cancellablePromise(_services.GeogroupService.getNewsPosts(geogroup.id, {
          ordering: '-created',
          page: 1,
          pageSize: 3
        }));
        setNewsPosts(news);
      }
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        enqueueSnackbar(t('commons.news.server_error'), {
          variant: 'error'
        });
      }
    }
  }
  const Button = _Button || _components.Button;
  return /*#__PURE__*/_react.default.createElement(_Card2.default, _extends({
    elevation: 0,
    sx: {
      borderRadius: '16px',
      overflowY: 'auto',
      ...sx
    },
    variant: "elevation"
  }, props), /*#__PURE__*/_react.default.createElement(_CardContent2.default, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      padding: 3
    }
  }, newsPosts ? newsPosts.length > 0 ? newsPosts.map((newsPost, index) => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: newsPost.id
  }, index > 0 && /*#__PURE__*/_react.default.createElement(_Divider2.default, null), /*#__PURE__*/_react.default.createElement(_components.NewsPostCard, {
    currentPartner: currentPartner,
    currentUser: currentUser,
    editPath: `../post/${newsPost.id}/update`,
    geogroup: geogroup,
    Link: Link,
    newsPost: newsPost,
    onRemoved: getNewsPosts,
    small: small,
    userType: userType
  }))) : /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, userType === 'admin' ? /*#__PURE__*/_react.default.createElement("img", {
    src: _newsPostAlert.default,
    width: "60px"
  }) : /*#__PURE__*/_react.default.createElement("img", {
    src: _plottyEmptyState.default,
    style: {
      alignSelf: 'center'
    },
    width: "280px"
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 600
  }, t('commons.news.empty_state_title', {
    context: userType
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, t('commons.news.empty_state_description', {
    context: userType
  })), userType === 'admin' && /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    component: Link,
    to: newPostRedirection || '/new-post',
    variant: "contained"
  }, t('commons.news.actions.create_long'))) : [0, 1, 2].map((key, index) => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: key
  }, index > 0 && /*#__PURE__*/_react.default.createElement(_Divider2.default, null), /*#__PURE__*/_react.default.createElement(_components.NewsPostCard, null)))));
}